
import React from "react";
import img1 from "./imgs/4-R-Smart Expert-c.jpg";
import {DEFAULT_LOCALE, LOCALES_HELPER} from "../../../../locales/config";
import img1en from "./imgs/4-R-Smart Expert.jpg";

export function RSmartWExpert() {

    const lang = LOCALES_HELPER.getLan();

    return (
        <>
            {lang === DEFAULT_LOCALE
                ? <>
                    <img className="product-img" src={img1}/>
                </>
                : <>
                    <img className="product-img" src={img1en}/>
                </>
            }
        </>
    )
}